import React, { Component } from 'react';
import ImageGallery from 'react-image-gallery';

export default class CarImage extends React.Component {
	
	// https://github.com/xiaolin/react-image-gallery
	
	constructor(props) {
		
		super(props);
		
		this.state = {
			loaded: false
		};
	}
	
	getImageObj(src) {
		
		return {
			original: src,
			thumbnail: src
		};
	}
	
	onImageLoad = () => !this.state.loaded && this.setState({ loaded: true });
	
	render() {
		
		const { getImageObj, onImageLoad } = this;
		
		const { image } = this.props;
		
		const images = this.state.loaded ? image.map(i => getImageObj(i)) : [getImageObj(image[0])];
		
		return (
			<ImageGallery
				items={images}
				onImageLoad={onImageLoad}
				lazyLoad={true}
				showFullscreenButton={false}
				useBrowserFullscreen={false}
				showPlayButton={false}
			/>
		);
	}
}